import { render, staticRenderFns } from "./SubscriptionDetails.vue?vue&type=template&id=1d27a968"
import script from "./SubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDetails.vue?vue&type=style&index=0&id=1d27a968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports